"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useMatch } from "fansunited-data-layer/client";
import type { FUSportsFootballEventType } from "fansunited-data-layer";
import { formatMinute, getEffectiveMinute, isGoalEvent } from "@/views/match/partials/events/matchEventHelpers";
import { GoalIcon, YellowCardIcon, RedCardIcon } from "@/components/ui/icons/PlayerEventIcons";
const COMPACT_EVENT_TYPES: FUSportsFootballEventType[] = ["GOAL", "PENALTY_GOAL", "OWN_GOAL", "YELLOW_CARD", "RED_CARD", "YELLOW_RED_CARD"];
function EventIcon(t0) {
  const $ = _c(3);
  const {
    type
  } = t0;
  if (isGoalEvent(type)) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <GoalIcon />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (type === "RED_CARD" || type === "YELLOW_RED_CARD") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <RedCardIcon />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <YellowCardIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function CompactEvents() {
  const $ = _c(8);
  const {
    events
  } = useMatch();
  let t0;
  bb0: {
    if (!events || events.length === 0) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== events) {
      t1 = events.filter(_temp).sort(_temp2);
      $[1] = events;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const filteredEvents = t0;
  if (filteredEvents.length === 0) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-center py-6 text-muted-foreground text-sm">No key events</p>;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== filteredEvents) {
    t1 = filteredEvents.map(_temp3);
    $[4] = filteredEvents;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <div className="divide-y divide-border/50">{t1}</div>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp3(event) {
  const playerName = event.primaryPlayer?.name || "";
  const isGoal = isGoalEvent(event.type);
  const isHome = event.competitorPosition === "ONE";
  const scoreLabel = isGoal && event.score ? `${event.score.competitorOne} - ${event.score.competitorTwo}` : null;
  return <div key={event.id} className="grid grid-cols-[1fr_auto_1fr] items-center py-2.5 gap-x-3">{isHome ? <div className="flex items-center justify-end gap-2">{scoreLabel && <span className="text-xs font-semibold text-muted-foreground tabular-nums">{scoreLabel}</span>}<span className="text-sm text-foreground truncate">{playerName}</span><EventIcon type={event.type} /></div> : <div />}<span className="text-xs font-medium text-muted-foreground tabular-nums text-center w-10 shrink-0">{formatMinute(event)}</span>{!isHome ? <div className="flex items-center justify-start gap-2"><EventIcon type={event.type} /><span className="text-sm text-foreground truncate">{playerName}</span>{scoreLabel && <span className="text-xs font-semibold text-muted-foreground tabular-nums">{scoreLabel}</span>}</div> : <div />}</div>;
}
function _temp2(a, b) {
  return getEffectiveMinute(a) - getEffectiveMinute(b);
}
function _temp(e) {
  return COMPACT_EVENT_TYPES.includes(e.type as FUSportsFootballEventType);
}